import React, { useEffect, useRef, useState } from 'react';
import classes from './PdfViewer.module.css';

const PdfViewer = ({ data, contentDirPath = '' }) => {

    const [currentPage, setCurrentPage] = useState();
    const [menu, setMenu] = useState();
    const [showMenu, setShowMenu] = useState(true);
    const [load, setLoad] = useState(true);
    const pdfViewerRef = useRef();

    useEffect(() => {
        let firstPage = null;
        setLoad(true);
        setMenu(null);
        (async () => {
            let doc;
            if (window.cmsPdfDocs && window.cmsPdfDocs[data.url])
                doc = window.cmsPdfDocs[data.url]
            else {
                doc = await window.pdfjsLib.getDocument(`${contentDirPath}${data.url}`).promise;
                if (!window.cmsPdfDocs)
                    window.cmsPdfDocs = {};
                window.cmsPdfDocs[data.url] = doc
            }

            if (data.pageNum) {
                let page = await doc.getPage(data.pageNum);
                await renderPage(page, 0);
            }
            else {
                let pagesArr = await Promise.all([...new Array(doc.numPages)].map(async (x, num) => {
                    let page = await doc.getPage(num + 1);
                    if (num === 0)
                        firstPage = page;
                    let canvas = await makeThumb(page);
                    return <div className={classes.PreviewItem}
                        style={{ width: canvas.width + 4, height: canvas.height + 4 }}
                        key={page._pageIndex}
                        ref={ref => {
                            if (ref) {
                                ref.innerHTML = "";
                                ref.appendChild(canvas)
                            }
                        }}
                        onClick={() => renderPage(page, num)}
                        id={"pagePdfViewer" + num}
                    ></div>;
                }))
                setMenu(pagesArr);
                await renderPage(firstPage, 0);
            }
            setLoad(false)
        })();
    }, [data])

    const renderPage = async (page, pageNum) => {
        var canvas = document.createElement("canvas");
        var scales = { 1: 3.2, 2: 4 },
            defaultScale = 3,
            scale = scales[window.devicePixelRatio] || defaultScale;

        var viewport = page.getViewport({ scale: scale });
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const viewerWidth = pdfViewerRef.current && data ? pdfViewerRef.current.offsetWidth - 15 : 865;
        var displayWidth = viewerWidth / viewport.width;
        canvas.style.width = `${(viewport.width * displayWidth)}px`;
        canvas.style.height = `${(viewport.height * displayWidth)}px`;

        const pdfElems = await page.render({ canvasContext: canvas.getContext("2d"), viewport: viewport }).promise.then(function () {

            return page.getAnnotations().then(function (annotationData) {
                if (annotationData.length == 0)
                    return [canvas];

                const annotationLayerElem = document.createElement("div");
                annotationLayerElem.className = classes.AnnotationLayer;
                const LinkService = new window.pdfjsViewer.PDFLinkService()
                LinkService.externalLinkTarget = window.pdfjsLib.LinkTarget.SELF;
                annotationData = annotationData.map(a => ({ ...a, url: a.unsafeUrl }));
                const nla = {
                    viewport: viewport.clone({ dontFlip: true }),
                    div: annotationLayerElem,
                    annotations: annotationData,
                    page: page,
                    linkService: LinkService
                }
                window.pdfjsLib.AnnotationLayer.render(nla);

                const links = annotationLayerElem.querySelectorAll('section[data-annotation-id]');
                links.forEach(link => {
                    const leftValue = parseFloat(link.style.left);
                    const topValue = parseFloat(link.style.top);
                    const widthValue = parseFloat(link.style.width);
                    const heightValue = parseFloat(link.style.height);

                    const data = link.dataset.annotationId;
                    const annotation = annotationData.find(a => a.id === data);
                    if (annotation) {
                        link.style.position = 'absolute';
                        link.style.left = `${(leftValue * displayWidth * scale)}px`;
                        link.style.top = `${(topValue * displayWidth * scale)}px`;
                        link.style.width = `${widthValue * displayWidth}px`;
                        link.style.height = `${heightValue * displayWidth}px`;
                    }
                });

                return [canvas, annotationLayerElem];
            })

        });

        setCurrentPage(
            <div className={classes.CanvasWrap} ref={ref => {
                if (ref) {
                    ref.innerHTML = "";
                    pdfElems.forEach(element => {
                        ref.appendChild(element)
                    });
                }
            }} />
        )
        const preSelected = document.getElementsByClassName(classes.SelectedPreviewItem);
        if (preSelected && preSelected.length > 0)
            preSelected[0].classList.remove(classes.SelectedPreviewItem)
        const selected = document.getElementById("pagePdfViewer" + pageNum)
        if (selected)
            selected.classList.add(classes.SelectedPreviewItem);

    }

    const makeThumb = (page) => {
        const vp = page.getViewport({ scale: 1 });
        const p = vp.width / vp.height;
        const canvas = document.createElement("canvas");
        const width = 75 * p;
        const height = 75;
        const scale = height / vp.height;
        canvas.width = width;
        canvas.height = height;
        return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
            return canvas;
        });
    }

    return (
        <div className={classes.PdfViewer} ref={pdfViewerRef}>
            {load ?
                <div className={classes.Loader}></div> :
                <div className={classes.ViewerWrap}>
                    <div className={classes.Viewer}>
                        {currentPage}
                    </div>
                    {menu && <div className={classes.MenuListHover} onMouseEnter={() => { setShowMenu(true) }} onMouseLeave={() => { setShowMenu(false) }}>
                        <div className={`${classes.Menu} ${showMenu && classes.Show}`}>
                            <div className={classes.MenuList}>
                                {menu}
                            </div>
                        </div>
                    </div>}
                </div>
            }
        </div>
    );
}



export default PdfViewer;
